import { Slider } from "../slider/slider";


export class TvScheduleSlider {
    defaultOptions = {
        wrapperClass:   'structure__content',
        slideClass:     'tv-schedule__nav__item',
        slidesPerView:  5,
        slidesPerGroup: 5,
        initialSlide:   5,
        breakpoints: {
            980: {
                slidesPerView: 3,
                slidesPerGroup: 3
            },
            740: {
                slidesPerView: 5,
                slidesPerGroup: 5
            },
            615: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                initialSlide: 2
            }
        },
        navigation: {
            prevEl: '.tv-schedule__navigation--prev',
            nextEl: '.tv-schedule__navigation--next'
        }
    };

    swipers = [];

    // staff
    structures;

    constructor(slider) {
        this.slider = slider;

        this.init();
    }

    init() {
        this.structures = $(this.slider).find('.md-slider-tvschedule');

        if (!this.structures.length) {
            return;
        }

        this.swipers.push(new Slider(this.structures, this.defaultOptions));

        return this.swipers;
    }
}
